module.exports = __webpack_public_path__ + "static/media/ABW.9a43b0ed.svg";